import {
  IconNameEnum,
  useActivitiesStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreActivitiesComponent } from "@b2bportal/core-types";
import {
  type ActivityLocationSuggestion,
  fetchLocations,
  useActivityLocationAutocomplete,
} from "@tenant/activities";
import {
  Icon,
  LocationAutocomplete,
  type LocationAutocompleteProps,
} from "@tenant/ui";

export interface ActivityLocationAutocompleteProps
  extends Omit<
    LocationAutocompleteProps<ActivityLocationSuggestion>,
    "fetch" | "groupBy" | "getOptionLabel" | "sortOptions"
  > {
  value?: ActivityLocationSuggestion;
  defaultValue?: ActivityLocationSuggestion;
}

export const ActivityLocationAutocomplete = (
  props: ActivityLocationAutocompleteProps
) => {
  const styles = useActivitiesStyles(
    CoreActivitiesComponent.ActivityLocationAutocomplete,
    {}
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreActivitiesComponent.ActivityLocationAutocomplete
  );

  const { context, handlers } = useActivityLocationAutocomplete(props);

  return (
    <div className={block}>
      <LocationAutocomplete<ActivityLocationSuggestion>
        id={context.id}
        value={context.value}
        defaultValue={context.defaultValue}
        label={context.label}
        onChange={handlers.onChange}
        fetch={fetchLocations}
        getOptionLabel={getOptionLabel}
        icon={<Icon iconName={IconNameEnum.mapPin} />}
        className={context.className}
        paperClassName={cn("location-paper")}
        popperClassName={cn("location-popper")}
        onOpen={handlers.onOpen}
        placeholder={context.placeholder}
        getOptionIcon={getOptionIcon}
        useDialogOnMobile={context.useDialogOnMobile ?? true}
        error={props.error}
        onFocus={handlers.onFocus}
      />
    </div>
  );
};

const getOptionLabel = (value?: ActivityLocationSuggestion) => {
  if (!value) {
    return "";
  }

  return value.label || value.id.searchTerm;
};

// TODO(Sarah): Update this icon for activities accordingly based on design
const getOptionIcon = (value?: ActivityLocationSuggestion) => {
  return <Icon iconName={IconNameEnum.mapPin} />;
};
